import { css } from '@emotion/css/macro';
import Color from '../../../../common/Color';
import StyleConstants from '../../../../common/StyleConstants';

const style = css`
  max-width: ${StyleConstants.MAX_WIDTH}px;
  width: 100%;
  background: linear-gradient(to bottom, #4855d1 66%, #5949d2, #5949d2);
  padding: 80px 0 40px;
  #title-img {
    display: block;
    width: 200px;
    left: 0;
    right: 0;
    margin: 67px auto 0;
  }
`;
const textBoxWhite = css`
  animation-duration: 0.5s;
  animation-name: chatAnimationWhite;
  padding: 11px 21px;
  font-size: 16px;
  line-height: 1.19;
  letter-spacing: -0.6px;
  color: #42607f;
  background-color: ${Color.WHITE};
  border-radius: 13px 0 13px 13px;
  margin: 20px 27px;
  word-break: keep-all;
  b {
    font-weight: bold;
  }
  @keyframes chatAnimationWhite {
    from {
      margin-top: 0;
      margin-bottom: 40px;
      opacity: 0;
    }
    to {
      margin-top: 20px;
      margin-bottom: 20px;
      opacity: 1;
    }
  }
`;
const textBoxPink = css`
  animation-name: chatAnimationPink;
  animation-duration: 1.5s;
  display: block;
  padding: 11px 17px;
  color: ${Color.WHITE};
  background-color: #f48c95;
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.24);
  border-radius: 0 13px 13px 13px;
  margin: 5px 0;
  line-height: 1.31;
  letter-spacing: 0.6px;
  b {
    font-weight: bold;
  }
  @keyframes chatAnimationPink {
    0% {
      opacity: 0;
      margin-top: 0px;
      margin-bottom: 10px;
    }
    66% {
      opacity: 0;
      margin-top: 0px;
      margin-bottom: 10px;
    }
    100% {
      margin-top: 5px;
      margin-bottom: 5px;
      opacity: 1;
    }
  }
`;
const chatGroup = css`
  animation-name: chatAnimation;
  animation-duration: 1s;
  display: flex;
  flex-direction: row;
  margin-left: 27px;
  img {
    width: 34px;
    height: 34px;
    margin-right: 14px;
  }
  @keyframes chatAnimation {
    0% {
      opacity: 0;
    }
    50% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
`;
const chat = css`
  display: flex;
  flex-direction: column;
  p {
    font-size: 12px;
    font-weight: bold;
    line-height: 2;
    color: ${Color.WHITE};
  }
`;

export default function TitleView() {
  return (
    <section className={style}>
      <div className={textBoxWhite}>
        도와주세요😭 <b>&nbsp; 처음 강아지를 키우는 초보 보호자</b>
        입니다.
      </div>
      <div className={chatGroup}>
        <img src='//static.dogmate.co.kr/dogit/landing-v3/dogit-v3-dog-profile.png' />
        <div className={chat}>
          <p>도깃</p>
          <div className={textBoxPink} style={{ width: '110px' }}>
            <b>안녕하세요</b> 👋
          </div>
          <div className={textBoxPink}>
            <b>반려동물과 함께 사는 방법,</b>
            <br />
            도깃이 알려드릴게요!
          </div>
        </div>
      </div>
      <img id='title-img' src='//static.dogmate.co.kr/dogit/landing-v3/dogit-v3-title-img.png' />
    </section>
  );
}
